































































































// Convention: 'm' if for MIRROR; mTitle = MIRROR PROPS TITLE
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class ComponentMenu extends Vue {
  @Prop({ type: String })
  public title!: string

  protected showMenu: boolean = false
  private items: any[] = []
  private mTitle: string = 'Expomoto'

  protected toggleMenu (): void {
    this.showMenu = !this.showMenu
  }

  private beforeMount () {
    console.log('Component :: Menu')
    if (typeof this.title !== 'string') this.mTitle = this.title
    this.items = [
      { icon: 'mdi-star-box', text: 'Información del Evento', to: 'EventoInfo' },
      { icon: 'mdi-ticket-account', text: 'Boletos', to: 'Boletos' },
      { icon: 'mdi-ticket', text: 'Boletos Especiales', to: 'BoletosEspeciales' },
      { icon: 'mdi-cash-register', text: 'Ventas', to: 'ViewVentas' },
      { icon: 'assignment_ind', text: 'Usuarios', to: 'ViewUsuarios' },
      { icon: 'settings', text: 'Configuracion', to: 'Configuracion' },
    ]
  }
  // { icon: 'mdi-clipboard', text: 'Reportes Tienda', to: 'ReportesTienda' },
}
